import { ApiClient } from './api-client';

// Get API URL from environment or use default
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api/v1';

// Create singleton API client instance
export const apiClient = new ApiClient({
  baseUrl: API_URL,
  enableLogging: import.meta.env.DEV,
  timeout: 30000,
  onTokenRefresh: (token: string) => {
    localStorage.setItem('accessToken', token);
  },
  onAuthError: () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    if (!window.location.pathname.includes('/login')) {
      window.location.href = '/login';
    }
  },
});

// Set initial token from localStorage if available
const token = localStorage.getItem('accessToken');
if (token) {
  apiClient.setAccessToken(token);
}

    